import React from 'react';
import PropTypes from 'prop-types';
import IdVerificationExpiredTag from '../../../../../components/IdVerificationExpiredTag';
import IdVerifiedTag from '../../../../../components/IdVerifiedTag';
import { getIsRenterIdVerified, getIsRenterIdVerifiedAndExpired } from '../../../../../utils/applicantDetailsUtil';
import NotIdVerifiedTag from '../../../../../components/NotIdVerifiedTag';

export default function OverviewIdVerifiedTag({ applicant }) {
  const { idVerificationInfo: { status, expiration } = {} } = applicant;
  if (getIsRenterIdVerified(status, expiration)) {
    return <IdVerifiedTag />;
  }
  if (getIsRenterIdVerifiedAndExpired(status, expiration)) {
    return <IdVerificationExpiredTag />;
  }
  return <NotIdVerifiedTag />;
}

OverviewIdVerifiedTag.propTypes = {
  applicant: PropTypes.shape({
    idVerificationInfo: PropTypes.shape({
      status: PropTypes.string,
      expiration: PropTypes.number,
    }),
  }),
};
